import React from 'react'
import styled from 'styled-components'
import { Checkbox } from '../../components/Checkbox'
import { SCREEN_SIZE, STYLES } from '../../static/style'
import { DeveloperFilter } from './DeveloperFilter'

const SectorOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const StyledCheckbox = styled(Checkbox)`
  width: 100%;
  > span {
    font-size: ${STYLES.FONT_SIZE_SM};
  }
  ${SCREEN_SIZE.SM} {
    width: 25%;
  }
`

interface ISectorFilterProps {
  value?: string
  onChange: (value?: string) => void
  name?: string
  isCollapsible?: boolean
  labelHeader?: string
}

const SchoolSectorFilter: React.FC<ISectorFilterProps> = ({
  value,
  onChange,
  isCollapsible = true,
  labelHeader = 'Sector Filter',
}) => {
  const onCheck = (ev, text) => {
    const { checked } = ev.target
    if (checked) {
      onChange(text)
    } else {
      onChange(undefined)
    }
  }
  return (
    <DeveloperFilter labelHeader={labelHeader} isCollapsible={isCollapsible}>
      <SectorOptions>
        <StyledCheckbox
          text="Government"
          onChange={onCheck}
          checked={value === 'Government'}
        />
        <StyledCheckbox
          text="Independent"
          onChange={onCheck}
          checked={value === 'Independent'}
        />
        <StyledCheckbox
          text="Catholic"
          onChange={onCheck}
          checked={value === 'Catholic'}
        />
      </SectorOptions>
    </DeveloperFilter>
  )
}

export { SchoolSectorFilter }
